module.exports = __webpack_public_path__ + "static/use-case-1-content-3-259d406c0e9bd5ade76c4322813d3fd9.png";